/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import AgentHeader from "./AgentHeader";
import AgentMessage from "./AgentMessage";
import SuggestedActions from "./SuggestedActions";
import ChatMessage from "./ChatMessage";
import AgentFooter from "./AgentFooter";
import "../../../styles/IntakeAgent.css";
import { AGENTS } from "../agents/agentRegistry";
import { useLocation, useNavigate } from "react-router-dom";
import getSuggestedActionLabels from "../../../utils/getSuggestedActionLabels";
import INTENT_TYPES from "../../../constants/intentTypes";
import { pollProgress } from "../../../utils/agenticApiClient";
import AgentActionTray from "./AgentActionTray";
import { extractStreamText } from "../../../utils/streamExtract";
import { retrieveConversationMessages } from "../../../api/agentic/agentConversationApi";
import { resolveSessionActive } from "../../../utils/sessionProbe";

const reportPayloadHasContent = (report) => {
  if (!report) return false;
  if (report.summary) return true;
  if (Array.isArray(report.documents) && report.documents.length > 0) return true;
  if (Array.isArray(report.documentRows) && report.documentRows.length > 0) return true;
  if (Array.isArray(report.matches) && report.matches.length > 0) return true;
  if (report.outputText) return true;
  return false;
};

const IntakeAgentPanel = ({
  userName = "User",
  applicationCount = 9,
  onRunDuplicateCheck,
  onSaveForLater,
  onClose,
  agentName,
  isReviewAgentScreen,
  defaultMsg = null,
  logedInUserMail,
  isAgentPanelOpen,
}) => {
  const storageKey = useMemo(() => {
    const safeAgentName = (agentName || "unknown-agent").replace(/\s+/g, "-").toLowerCase();
    const safeUser = (logedInUserMail || "unknown-user").toLowerCase();
    return `agentic-thread:${safeUser}:${safeAgentName}`;
  }, [agentName, logedInUserMail]);

  const conversationStateKey = useMemo(() => {
    const safeAgentName = (agentName || "unknown-agent").replace(/\s+/g, "-").toLowerCase();
    const safeUser = (logedInUserMail || "unknown-user").toLowerCase();
    return `agentic-conversation:${safeUser}:${safeAgentName}`;
  }, [agentName, logedInUserMail]);

  const toChatMessage = (threadMessage) => {
    const role = String(threadMessage?.role || "").toLowerCase();
    const sender = role === "user" ? "user" : "agent";
    return {
      sender,
      text: threadMessage?.content || "",
      status: "complete",
    };
  };

  const getMessageBody = useCallback((msg) => String(msg?.text || msg?.summary || "").trim(), []);

  const getMessageMatchKey = useCallback((msg) => {
    const sender = String(msg?.sender || "").toLowerCase();
    const body = getMessageBody(msg).replace(/\s+/g, " ").trim();
    return `${sender}::${body}`;
  }, [getMessageBody]);

  const normalizeMessageContent = (msg) => {
    if (!msg || msg.sender !== "agent") return msg;

    const normalizedText = String(msg.text || "").trim();
    const normalizedSummary = String(msg.summary || "").trim();

    if (normalizedText && normalizedSummary && normalizedText === normalizedSummary) {
      return {
        ...msg,
        summary: "",
      };
    }

    return msg;
  };

  const shouldForceReportButton = useCallback((msg) => {
    if (!msg || msg.sender !== "agent") return false;

    const currentAgentId = AGENTS[agentName]?.id;
    if (currentAgentId === "DocumentProcessingAgent") {
      const totalFiles = Number(
        msg?.counts?.total_files
        ?? msg?.counts?.totalFiles
        ?? msg?.outputText?.output_text?.caseSummary?.totalFiles
        ?? 0,
      );
      return (
        (Array.isArray(msg?.documentRows) && msg.documentRows.length > 0)
        || (Array.isArray(msg?.documents) && msg.documents.length > 0)
        || totalFiles > 0
      );
    }

    if (currentAgentId === "benefit-agent-b1") {
      const intent = String(msg?.intent || msg?.raw?.output_text?.intent || "").toLowerCase();
      return Boolean(
        intent.includes(INTENT_TYPES.DOB_CHECK)
        || intent.includes(INTENT_TYPES.DUPLICATE)
        || msg?.type === "duplicate_result"
        || (Array.isArray(msg?.matches) && msg.matches.length > 0)
        || msg?.sourceCaseId
      );
    }

    return false;
  }, [agentName]);

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const runningRef = useRef(false);
  const activeRunRef = useRef(null);
  const [historyHydrated, setHistoryHydrated] = useState(false);
  const [lastRestoreKey, setLastRestoreKey] = useState("");
  const { runDuplicateLabel, saveLaterLabel } = getSuggestedActionLabels(agentName);
  const followBottomRef = useRef(true);
  const triggerDuplicateCheck = () => {
    const userPrompt = `Run duplicate check on all ${applicationCount} applications`;

    setMessages((prev) => [...prev, { sender: "user", text: userPrompt }]);
    onRunDuplicateCheck?.();

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          sender: "agent",
          text: `Got it! I'm reviewing ${applicationCount} applications for duplicate check:`,
          tasks: [
            { label: "Running Fuzzy Matching across historical applications", status: "done" },
            { label: "Checking applicant details", status: "done" },
            { label: "Checking mailing address details", status: "done" },
            { label: "Checking damaged property details", status: "progress" },
          ],
          showSuggestedActions: true,
        },
      ]);
    }, 800);
  };
const mapChatResponse = (config, showReport, normalized, streamedText="") => {
    setMessages((prev) => {
      const updated = [...prev];
 
      // Find last "thinking" message
      const thinkingIndex = updated
        .map((m, i) => (m.status === "thinking" ? i : -1))
        .filter((i) => i !== -1)
        .pop();
 
      if (thinkingIndex === undefined) return updated;
 
      if (normalized) {
        
        // const streamedText = updated[thinkingIndex].text;
        const finalText = normalized.response || normalized.text || streamedText||"";
        const hasSummaryBlock = !!normalized.summary;

        updated[thinkingIndex] = {
          sender: "agent",
          agent: config?.id,
          ...normalized,
          text: hasSummaryBlock?"": finalText,
          status: "complete",
          showViewReportButton: showReport,
          steps: updated[thinkingIndex].steps || [],
        };
      } else {
        updated.splice(thinkingIndex, 1);
      }
 
      return updated;
    });
  };

  const handleSendMessage = async (text) => {
        if (!text?.trim() || isLoading || runningRef.current) return;
    runningRef.current =true;
    
    setMessages((prev) => [...prev, { sender: "user", text }]);
    setIsLoading(true);
    setMessages((prev) => [
      ...prev,
      {
        sender: "agent", text: "", status: "thinking", id: Date.now(), steps:[],
      },
    ]);

    try {
      const agentConfig = AGENTS[agentName];

      if (!agentConfig?.sendMessage) {
        throw new Error("sendMessage not defined for agent");
      }

      // Auth is handled inside the central agenticApiClient now — no more
      // REACT_APP_AGENTIC_AZURE_AI_TOKEN env var; the BFF mints a JWT and the
      // client attaches it automatically.
    //   const raw = await agentConfig.sendMessage({
    //     message: text,
    //     agentConfigName: agentConfig,
    //     threadId,
    //   },
    //   {
    //     onStep: ({id, label, status})=>{
    //       setTasks((prev) =>{
    //         const i = prev.findIndex((t)=> t.id === id);
    //         if(i===-1) return [...prev, {id, label, status}];
    //         const next = [...prev];
    //         next[i] ={...next[i], ...AGENTS(label ? { label}: {}), status };
    //         return next;
    //       });
    //     }
    //   },
      
    // );
    // setTasks([]);
// Generate a run id and poll progress while the (blocking) POST runs.
      const runId = (crypto.randomUUID && crypto.randomUUID())
        || `run-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      activeRunRef.current = runId;
      let sinceSeq = 0;
      let polling = true;

      // --- Smooth typewriter reveal ---

      // Tokens arrive in ~1s polling batches; we buffer them and reveal

      // character-by-character on a fast timer so it looks like live typing.

      let receivedText = "";   // everything received from polling so far
      let  rawBuffer=""
      let shownLength = 0;     // how many chars we've revealed into the bubble
      const streamKey = agentConfig.streamKeys;
      const appendToBuffer = (text) => {

        if (text){
          
          rawBuffer += text;
          receivedText = extractStreamText(rawBuffer, streamKey);

        }

      };
 
      const updateThinkingText = (fullText) => {
        
        setMessages((prev) => {

          const idx = prev

            .map((m, i) => (m.status === "thinking" ? i : -1))

            .filter((i) => i !== -1)

            .pop();

          if (idx === undefined) return prev;

          const next = [...prev];

          next[idx] = { ...next[idx], text: fullText };

          return next;

        });

      };
 
      const revealTimer = setInterval(() => {

        if (shownLength < receivedText.length) {

          // reveal a few chars per tick for a natural pace
          const remaining = receivedText.length -  shownLength
          const step = Math.max(2, Math.ceil(remaining/30));

          shownLength = Math.min(shownLength + step, receivedText.length);

          updateThinkingText(receivedText.slice(0, shownLength));

        }

      }, 25);
 

      const applyEvent = ({ id, label, done_label,status }) => {
        setMessages((prev) => {
          const idx = prev
            .map((m, i) => (m.status === "thinking" ? i : -1))
            .filter((i) => i !== -1)
            .pop();
          if (idx === undefined) return prev;
          const next = [...prev];
          const existing = next[idx].steps || [];
          const j = existing.findIndex((s) => s.id === id);
          const steps = j === -1
            ? [...existing, { id, label,done_label, status }]
            : existing.map((s, k) => (k === j 
              ? { ...s, ...(label ? { label } : {}), ...(done_label ? { done_label } : {} ), status } : s));
          next[idx] = { ...next[idx], steps };
          return next;
        });
      };
 
      const poll = async () => {
        while (polling && activeRunRef.current === runId) {
          try {
            const res = await pollProgress(runId, sinceSeq);
           
            sinceSeq = res.next_seq;
            (res.events || []).forEach((ev) => {
              if (activeRunRef.current !== runId) return;
              if (ev.type === "step") {
              
                applyEvent(ev);
              }
              else if (ev.type ==="token") { appendToBuffer(ev.text);}
            });
            if (res.done) break;
          } catch (err) {
            console.log('POLL ERROR:', err);
            // best-effort; keep polling until the POST resolves
          }
          await new Promise((r) => setTimeout(r, 1000));
        }
      };
      poll();
 
      let raw;
      
      try {
        raw = await agentConfig.sendMessage({
          message: text,
          agentConfigName: agentConfig,
          threadId,
          run_id: runId,
        });
      } finally {

        polling = false;

        clearInterval(revealTimer);


      }

      try{
        const finalRes =  await pollProgress(runId,sinceSeq);
        (finalRes.events || []).forEach((ev)=>{
          if (ev.type==="step") applyEvent(ev);
        });
      } catch (err){
        
      }
 

      const normalized = agentConfig.normalize(raw);
      if (!threadId && raw.thread_id) {
        setThreadId(raw.thread_id);
      }
      const reportPayload = agentConfig.id === "DocumentProcessingAgent"
        ? {
          agentId: agentConfig.id,
          ...normalized,
        }
        : {
          agentId: agentConfig.id,
          summary: raw.response,
          counts: normalized.counts,
          matches: normalized.matches,
          clusters: normalized.clusters,
          sourceCaseId: normalized.source_case_id,
          input_record: normalized.outputText?.output_text?.input_record,
          intent: normalized.intent,
          agent: normalized.agent,
        };

      // setReportData(reportPayload);
      const REPORT_ENABLED_AGENTS = [
        "review-intake-a1",
        "benefit-agent-b1",
        "application-status-agent",
        "eligibility-review-agent",
        "eligibility-review-agent-e1",
        "DocumentProcessingAgent",
        "eligibility-review-agent-e1",
      ];

      const isReportEnabledAgent = REPORT_ENABLED_AGENTS.includes(agentConfig.id);

      let showViewReportButton = false;
      if (agentConfig.id === "DocumentProcessingAgent") {
        const totalFiles = Number(
          normalized?.counts?.total_files
          ?? normalized?.counts?.totalFiles
          ?? normalized?.outputText?.output_text?.caseSummary?.totalFiles
          ?? 0,
        );
        const hasDocumentRows = Array.isArray(normalized?.documentRows)
          && normalized.documentRows.length > 0;
        const hasDocuments = Array.isArray(normalized?.documents)
          && normalized.documents.length > 0;

        // Show if document analysis payload exists
        showViewReportButton = hasDocumentRows || hasDocuments || totalFiles > 0;
      } else if (agentConfig.id === "benefit-agent-b1") {
        const intent = String(normalized.intent || normalized.raw?.output_text?.intent || "").toLowerCase();
        showViewReportButton = Boolean(
          intent.includes(INTENT_TYPES.DOB_CHECK)
          || intent.includes(INTENT_TYPES.DUPLICATE)
          || normalized.type === "duplicate_result"
          || (Array.isArray(normalized.matches) && normalized.matches.length > 0)
          || normalized.sourceCaseId,
        );
      } else {
        const allowedIntents = [
          INTENT_TYPES.DUPLICATE_CHECK_BY_CASE_ID,
          INTENT_TYPES.STATUS_CHECK_BY_CASE_ID,
          INTENT_TYPES.ELGIBILITY_REVIEW,
        ];

        const intent = normalized.intent || normalized.raw?.output_text?.intent;

        showViewReportButton = isReportEnabledAgent && (allowedIntents.includes(intent));
      }
  
      mapChatResponse(agentConfig, showViewReportButton, normalized, receivedText);
    } catch (e) {
      console.error(e);

      let errorMessage = `Something went wrong while contacting the Agent. Try again shortly.`;

      try {
        const parsed = JSON.parse(e.message);
        errorMessage = parsed?.detail?.message
          || parsed?.message
          || errorMessage;
      } catch {
        errorMessage = e.message;
      }
      mapChatResponse({}, false, null);
      setMessages((prev) => [
        ...prev,
        { sender: "agent", type: "error", summary: errorMessage },
      ]);
    } finally {
      setIsLoading(false);
      runningRef.current =false;
    }
  };

  const handleSuggestedActions = (isSave = false) => {
    const prompt = isSave ? saveLaterLabel : runDuplicateLabel;
    handleSendMessage(prompt);
  };

  const getLastAgentId = () => {
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i].sender === "agent" && messages[i].agent) {
        return messages[i].agent;
      }
    }
    return null;
  };

  const getReportRouteByAgent = useCallback((agentId) => {
    switch (agentId) {
      case "review-intake-a1":
        if (agentName === "Application Status Agent") {
          return "/application-status-report";
        }
        return "/duplicate-report";

      case "benefit-agent-b1":
        return "/benefit-duplicate-report";

      case "DocumentProcessingAgent":
        return "/documentQuality-report";

      case "eligibility-review-agent-e1":
        return "/eligibility-review-report";
        
      case "application-status-agent":
        return "/application-status-report";

      default:
        return null;
    }
  }, [agentName]);

  const navigate = useNavigate();
  const location = useLocation();

  const handleViewReport = (normalized) => {
    const agentConfig = AGENTS[agentName];
    const isEligibilityAgent = agentConfig.id === "eligibility-review-agent-e1";
    let payload = {
      agentId: agentConfig.id,
      summary: isEligibilityAgent
        ? normalized.raw?.output_text?.report?.response : normalized.summary,
      counts: normalized.counts,
      matches: normalized.matches,
      clusters: normalized.clusters,
      sourceCaseId: normalized.source_case_id,
      input_record: isEligibilityAgent
        ? normalized.raw?.output_text?.case_data : normalized.outputText?.output_text?.input_record,
      intent: normalized.intent,
      agent: normalized.agent,
      documentRows: normalized.documentRows || [],
      documents: normalized.documents || [],
      type: "run_summary",
      caseRow: normalized.caseRow,
      outputText: normalized.apiResponse || normalized.outputText?.output_text,
      case_status: normalized.case_status,
      caseId: normalized.caseId,
    };

    const route = getReportRouteByAgent(payload.agentId);
    if (route) {
      const reportKey = `agentic-report:${route}`;
      try {
        if (reportPayloadHasContent(payload)) {
          window.sessionStorage.setItem(reportKey, JSON.stringify(payload));
        } else {
          const cached = window.sessionStorage.getItem(reportKey);
          if (cached) {
            const parsed = JSON.parse(cached);
            if (reportPayloadHasContent(parsed)) payload = parsed;
          }
        }
      } catch {
        
      }

      setReportData(payload);
      navigate(route, { state: { reportData: payload } });
    } else {
      setReportData(payload);
    }

    onClose?.();
  };
  const lastAgentId = getLastAgentId();

  const autoBottomRef = useRef(null);
  const defaultMessageAppliedRef = useRef(false);
  const handleSendMessageRef = useRef(handleSendMessage);
  const hasMessages = messages.length > 0;
  handleSendMessageRef.current = handleSendMessage;

  useEffect(() => {
    if (!isAgentPanelOpen) return;
    if (messages.length > 0) {
      setHistoryHydrated(true);
      return;
    }

    const restoreKey = `${storageKey}:${location.pathname}`;
    if (lastRestoreKey === restoreKey) {
      return;
    }
    setLastRestoreKey(restoreKey);

    const restoreConversation = async () => {
      const cachedConversationRaw = window.sessionStorage.getItem(conversationStateKey);
      let cachedConversation = null;
      if (cachedConversationRaw) {
        try {
          cachedConversation = JSON.parse(cachedConversationRaw);
        } catch {
          window.sessionStorage.removeItem(conversationStateKey);
        }
      }

      const cachedMessages = Array.isArray(cachedConversation?.messages)
        ? cachedConversation.messages.filter((m) => getMessageBody(m))
        : [];

      const storedThreadId = window.sessionStorage.getItem(storageKey);

      if (!storedThreadId) {
        if (cachedMessages.length > 0) {
          setMessages(cachedMessages);
          if (cachedConversation?.threadId) {
            setThreadId(cachedConversation.threadId);
          }
        }
        setHistoryHydrated(true);
        return;
      }

      setIsHistoryLoading(true);
      try {
        const hasSession = await resolveSessionActive();
        if (!hasSession) {
          window.sessionStorage.removeItem(storageKey);
          return;
        }

        const response = await retrieveConversationMessages(storedThreadId, {
          suppressAuthToast: true,
        });
        const historyMessages = Array.isArray(response?.messages)
          ? response.messages.map(toChatMessage).filter((m) => getMessageBody(m))
          : [];

        const cachedBuckets = new Map();
        cachedMessages.forEach((cachedMsg) => {
          const key = getMessageMatchKey(cachedMsg);
          const existing = cachedBuckets.get(key) || [];
          existing.push(cachedMsg);
          cachedBuckets.set(key, existing);
        });

        const mergedMessages = historyMessages.map((apiMsg) => {
          const key = getMessageMatchKey(apiMsg);
          const bucket = cachedBuckets.get(key);
          const cachedMsg = bucket && bucket.length > 0 ? bucket.shift() : null;

          if (cachedMsg) {
            return normalizeMessageContent({ ...apiMsg, ...cachedMsg });
          }

          return normalizeMessageContent(apiMsg);
        });

        const cachedAgentMessages = cachedMessages.filter(
          (m) => m?.sender === "agent" && m?.type !== "error",
        );
        let mergedAgentIndex = 0;
        for (let i = 0; i < mergedMessages.length; i += 1) {
          if (mergedMessages[i]?.sender === "agent") {
            const cachedAgentMsg = cachedAgentMessages[mergedAgentIndex];
            mergedAgentIndex += 1;

            const cachedHasReport = Boolean(cachedAgentMsg?.showViewReportButton)
              || (cachedAgentMsg ? shouldForceReportButton(cachedAgentMsg) : false);

            if (cachedHasReport && !mergedMessages[i]?.showViewReportButton) {
              mergedMessages[i] = normalizeMessageContent({
                ...mergedMessages[i],
                ...cachedAgentMsg,
                showViewReportButton: true,
              });
            }
          }
        }

        setThreadId(storedThreadId);
        setMessages(
          (mergedMessages.length > 0 ? mergedMessages : cachedMessages).map(normalizeMessageContent),
        );
      } catch (error) {
        console.warn("Failed to restore thread conversation", error);
        if (cachedMessages.length > 0) {
          setMessages(cachedMessages.map(normalizeMessageContent));
          setThreadId(cachedConversation?.threadId || storedThreadId);
        } else {
          window.sessionStorage.removeItem(storageKey);
        }
      } finally {
        setIsHistoryLoading(false);
        setHistoryHydrated(true);
      }
    };

    restoreConversation();
  }, [conversationStateKey, getMessageBody, getMessageMatchKey, isAgentPanelOpen, lastRestoreKey, location.pathname, messages.length, shouldForceReportButton, storageKey]);

  useEffect(() => {
    if (threadId) {
      window.sessionStorage.setItem(storageKey, threadId);
    }
  }, [storageKey, threadId]);

  useEffect(() => {
    if (threadId && messages.length > 0) {
      const normalizedForStorage = messages.map((msg) => {
        if (msg?.showViewReportButton) return msg;
        if (!shouldForceReportButton(msg)) return msg;
        return { ...msg, showViewReportButton: true };
      });

      window.sessionStorage.setItem(
        conversationStateKey,
        JSON.stringify({ threadId, messages: normalizedForStorage }),
      );
    }
  }, [conversationStateKey, messages, shouldForceReportButton, threadId]);

  useEffect(() => {
      const el = autoBottomRef.current;
      if (!el) return;
      const container = el.parentElement;
      if (!container) return;
  
      const onScroll = () => {
        const distanceFromBottom =
          container.scrollHeight - container.scrollTop - container.clientHeight;
        // If the user is within 80px of the bottom, keep following; otherwise they've scrolled up.
        followBottomRef.current = distanceFromBottom < 200;
      };
  
      container.addEventListener("scroll", onScroll, { passive: true });
      return () => container.removeEventListener("scroll", onScroll);
    }, [hasMessages]);  // re-attach when the container appears
  
  useEffect(() => {
    const el = autoBottomRef.current;
    if (!el) return;
    const container = el.parentElement;
    if (!container) return;
 
    const lastMsg = messages[messages.length - 1];
    const justSent =
      lastMsg &&
      (lastMsg.sender === "user" ||
        (lastMsg.sender === "agent" && lastMsg.status === "thinking" && !lastMsg.text));
 
    const isStreaming =
      lastMsg && lastMsg.sender === "agent" && lastMsg.status === "thinking";
 
    // Follow the stream only if the user hasn't scrolled away from the bottom.
    if (justSent || (isStreaming && followBottomRef.current) || followBottomRef.current) {
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
      });
    }
  }, [messages]);

  useEffect(() => {
    if (!defaultMsg || !historyHydrated || messages.length > 0 || defaultMessageAppliedRef.current) return;
    defaultMessageAppliedRef.current = true;
    handleSendMessageRef.current(defaultMsg);
  }, [defaultMsg, historyHydrated, messages.length]);

  let bodyContent = null;
  if (isHistoryLoading) {
    bodyContent = (
      <div className="chat-messages">
        <div className="single-message">
          <ChatMessage
            sender="agent"
            text=""
            status="thinking"
            agentName={agentName}
            onRunDuplicateCheck={onRunDuplicateCheck}
            onSaveForLater={onSaveForLater}
            logedInUserMail={logedInUserMail}
            isAgentPanelOpen={isAgentPanelOpen}
          />
        </div>
      </div>
    );
  } else if (messages.length > 0) {
    bodyContent = (
      <div className="chat-messages">
        {messages.map((msg, i) => (
          <div key={i} className="single-message">
            {(() => {
              const reportActionLabel = lastAgentId === "benefit-agent-b1"
                ? "Benefits Report"
                : "View Report";
              const priorUserMessage = [...messages.slice(0, i)]
                .reverse()
                .find((item) => item?.sender === "user" && String(item?.text || "").trim().length > 0);
              const userPromptForFeedback = String(priorUserMessage?.text || "").trim();

              return (
                <>
                 {msg.sender === "agent" && msg.steps && msg.steps.length > 0 && (
                    <AgentActionTray steps={msg.steps} status={msg.status}/>
                )}
            <ChatMessage
              {...msg}
              agentName={agentName}
              onRunDuplicateCheck={onRunDuplicateCheck}
              onSaveForLater={onSaveForLater}
              status={msg.status || "complete"}
              logedInUserMail={logedInUserMail}
              isAgentPanelOpen={isAgentPanelOpen}
            />

            {msg.sender === "agent"
              // && i === messages.length - 1
              && (
                <SuggestedActions
                  applicationCount={applicationCount}
                  onRunDuplicateCheck={() => handleViewReport(msg)}
                  onSaveForLater={onSaveForLater}
                  disabled={isLoading}
                  runDuplicateLabel={reportActionLabel}
                  reportData={reportData}
                  userId={logedInUserMail}
                  agentName={agentName}
                  threadId={threadId}
                  ratedMessage={msg?.summary || msg?.text || ""}
                  messageIndex={i}
                  chatHistory={messages}
                  userPrompt={userPromptForFeedback}
                  showFeedback={!(isLoading && i === messages.length - 1)}
                  showViewReportButton={
                    msg.showViewReportButton
                    || (
                      AGENTS[agentName]?.id === "DocumentProcessingAgent"
                      && (
                        (Array.isArray(msg?.documentRows) && msg.documentRows.length > 0)
                        || (Array.isArray(msg?.documents) && msg.documents.length > 0)
                        || Number(
                          msg?.counts?.total_files
                          ?? msg?.counts?.totalFiles
                          ?? msg?.outputText?.output_text?.caseSummary?.totalFiles
                          ?? 0,
                        ) > 0
                      )
                    )
                  }
                />
              )}
                </>
              );
            })()}
          </div>
        ))}

        <div ref={autoBottomRef} />
      </div>
    );
  } else {
    bodyContent = (
      <>
        <AgentMessage
          agentName={agentName}
          userName={userName}
          applicationCount={applicationCount}
          logedInUserMail={logedInUserMail}
        />

        <SuggestedActions
          applicationCount={applicationCount}
          onRunDuplicateCheck={() => handleSuggestedActions()}
          onSaveForLater={() => handleSuggestedActions(true)}
          showViewReportButton="true"
          runDuplicateLabel={runDuplicateLabel}
          userId={logedInUserMail}
          agentName={agentName}
          threadId={threadId}
          messageIndex={messages.length}
          chatHistory={messages}
          userPrompt=""
          showFeedback={false}
        />
      </>
    );
  }

 
  return (
    <div className="agent-container">
      <AgentHeader
        onClose={onClose}
        agentName={agentName}
        isReviewAgentScreen={isReviewAgentScreen}
      />

      <div className="agent-body">
       
        {bodyContent}


      </div>

      <AgentFooter onSendMessage={handleSendMessage} disabled={isLoading} isAgentPanelOpen={isAgentPanelOpen} />
    </div>
  );
};

export default IntakeAgentPanel;
